import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createSlots as _createSlots, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "Referentienummer", -1)
const _hoisted_3 = { class: "no-mb" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Vraag", -1)
const _hoisted_5 = { class: "no-mb" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, "Omschrijving", -1)
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "Gesteld door", -1)
const _hoisted_9 = { class: "no-mb" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "Gesteld op", -1)
const _hoisted_11 = { class: "no-mb" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "Aangeleverde bestanden", -1)
const _hoisted_13 = { key: 2 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "Categorie", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", null, "Referentienummer", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, "Gesteld door", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", null, "Gesteld op", -1)
const _hoisted_18 = { class: "no-mb" }

import { useRoute, useRouter } from 'vue-router'
import { questionStore } from '@/stores/question'
import { computed, onMounted, onBeforeUnmount } from 'vue'
import { IssueStatusColors } from '@/globalVariables'
import Filelist from '@/components/service/Filelist.vue'
import NewComment from '@/components/service/NewComment.vue'
import Comments from '@/components/service/Comments.vue'
import { generalStore } from '@/stores/general'


export default /*#__PURE__*/_defineComponent({
  __name: 'QuestionShow',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const title = computed(() => {
  const question = questionStore().question
  if (question) {
    return 'Vraag #' + question.id + ' - ' + question.title
  }

  return 'Vraag'
})

onMounted(() => {
  questionStore().getQuestion(route.params.questionId)
})

onBeforeUnmount(() => {
  questionStore().question = null
})

return (_ctx: any,_cache: any) => {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: [16,16] }, {
    default: _withCtx(() => [
      (_unref(generalStore)().appSettings?.notification?.pages.includes('Service'))
        ? (_openBlock(), _createBlock(_component_a_col, {
            key: 0,
            span: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_alert, {
                type: "info",
                class: "global-notification mb-16",
                message: _unref(generalStore)().appSettings.notification.title,
                "show-icon": ""
              }, {
                description: _withCtx(() => [
                  _createElementVNode("div", {
                    innerHTML: _unref(generalStore)().appSettings.notification.description
                  }, null, 8, _hoisted_1)
                ]),
                _: 1
              }, 8, ["message"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_a_col, {
        xs: {span: 24},
        sm: {span: 24},
        md: {span: 24},
        lg: {span: 16}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, {
                    loading: !_unref(questionStore)().question
                  }, _createSlots({
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(generalStore)().desktop ? _unref(title) : 'Vraag'), 1)
                    ]),
                    default: _withCtx(() => [
                      (!_unref(generalStore)().desktop)
                        ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _hoisted_2,
                                  _createElementVNode("p", _hoisted_3, "#" + _toDisplayString(_unref(questionStore)().question.id), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_a_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _hoisted_4,
                              _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(questionStore)().question.title), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_row, { class: "no-mb" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _hoisted_6,
                              _createElementVNode("div", {
                                innerHTML: _unref(questionStore)().question.body
                              }, null, 8, _hoisted_7)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (!_unref(generalStore)().desktop)
                        ? (_openBlock(), _createBlock(_component_a_row, { key: 1 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _hoisted_8,
                                  _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(questionStore)().question.reported), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (!_unref(generalStore)().desktop)
                        ? (_openBlock(), _createBlock(_component_a_row, { key: 2 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _hoisted_10,
                                  _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(questionStore)().question.created_at ? new Date(_unref(questionStore)().question.created_at).toLocaleDateString('nl-NL') : '-'), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (!_unref(generalStore)().desktop && _unref(questionStore)().question?.media.length)
                        ? (_openBlock(), _createBlock(_component_a_row, { key: 3 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _hoisted_12,
                                  _createVNode(Filelist, {
                                    media: _unref(questionStore)().question.media
                                  }, null, 8, ["media"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, [
                    (_unref(questionStore)().question)
                      ? {
                          name: "extra",
                          fn: _withCtx(() => [
                            (_unref(generalStore)().desktop)
                              ? (_openBlock(), _createBlock(_component_a_button, {
                                  key: 0,
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'Questions' })))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Terug naar vragen")
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_a_tag, {
                                  key: 1,
                                  color: _unref(IssueStatusColors)[_unref(questionStore)().question.status.id]
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(questionStore)().question.status.name), 1)
                                  ]),
                                  _: 1
                                }, 8, ["color"]))
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_unref(questionStore)().question)
            ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_card, {
                        title: "Berichten",
                        bordered: false
                      }, {
                        default: _withCtx(() => [
                          (![2, 4, 15].includes(_unref(questionStore)().question.status.id))
                            ? (_openBlock(), _createBlock(NewComment, {
                                key: 0,
                                "model-type": "questions",
                                "model-id": _unref(route).params.questionId,
                                onCommentCreated: _cache[1] || (_cache[1] = ($event: any) => (_unref(questionStore)().getQuestion(_unref(route).params.questionId)))
                              }, null, 8, ["model-id"]))
                            : _createCommentVNode("", true),
                          (_unref(questionStore)().question.comments.length)
                            ? (_openBlock(), _createBlock(Comments, {
                                key: 1,
                                comments: _unref(questionStore)().question.comments
                              }, null, 8, ["comments"]))
                            : (_openBlock(), _createElementBlock("p", _hoisted_13, "Geen berichten."))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_unref(questionStore)().question && _unref(generalStore)().desktop)
        ? (_openBlock(), _createBlock(_component_a_col, {
            key: 1,
            span: 8
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_card, { title: "Details" }, {
                        extra: _withCtx(() => [
                          _createVNode(_component_a_tag, {
                            color: _unref(IssueStatusColors)[_unref(questionStore)().question.status.id]
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(questionStore)().question.status.name), 1)
                            ]),
                            _: 1
                          }, 8, ["color"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_row, { class: "no-mb" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _hoisted_14,
                                  _createElementVNode("p", null, _toDisplayString(_unref(questionStore)().question.category === 1 ? 'Facturatie' : 'Algemeen'), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _hoisted_15,
                                  _createElementVNode("p", null, "#" + _toDisplayString(_unref(questionStore)().question.id), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _hoisted_16,
                                  _createElementVNode("p", null, _toDisplayString(_unref(questionStore)().question.reported), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _hoisted_17,
                                  _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(questionStore)().question.created_at ? new Date(_unref(questionStore)().question.created_at).toLocaleDateString('nl-NL') : '-'), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_unref(questionStore)().question.media.length)
                ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_card, { title: "Aangeleverde bestanden" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_row, { class: "no-mb" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_col, { span: 24 }, {
                                    default: _withCtx(() => [
                                      _createVNode(Filelist, {
                                        media: _unref(questionStore)().question.media
                                      }, null, 8, ["media"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})